export const loginSteps = {
    None: 0,
    ActivateAccount: 10,
    SetPassword: 20,
    SetPassCode: 30,
    SetSecurityQuestions: 40,
    EnterPassCode: 50,
    Complete: 60,
};
